(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/store/assets/javascripts/endpoints/draw.js') >= 0) return;  svs.modules.push('/components/tipsen/store/assets/javascripts/endpoints/draw.js');
"use strict";

const _svs$core = svs.core,
  socket = _svs$core.socket,
  log = _svs$core.log;
const _svs$components$lbUti = svs.components.lbUtils.apiProxy,
  ApiProxy = _svs$components$lbUti.ApiProxy,
  http = _svs$components$lbUti.http,
  featureToggle = _svs$components$lbUti.featureToggle;
const cloudApiFeatureToggles = svs.components.lbUtils.cloudApi.cloudApiConstants.cloudApiFeatureToggles;
const products = svs.utils.products;
const _svs$components$tipse = svs.components.tipsen.store.helpers,
  normalizeDrawForecast = _svs$components$tipse.normalizeDrawForecast,
  normalizeDrawResult = _svs$components$tipse.normalizeDrawResult;
const TWO_MINUTES = svs.components.tipsen.store.endpoints.constants.timeAsSeconds.TWO_MINUTES;
const getDefinitionByProduct = svs.components.tipsen.engine.utils.getDefinitionByProduct;
const drawSubscriptionActions = svs.components.tipsen.store.reducers.playerWager.actions;
const logger = log.getLogger('store:api');
const resolveDrawForecastPath = _ref => {
  let drawNumber = _ref.drawNumber,
    productId = _ref.productId;
  const productDrawName = products.getSpecificDrawName(productId);
  const drawForecastUrl = "/draw/1/".concat(productDrawName, "/draws/forecast/").concat(drawNumber);
  return drawForecastUrl;
};
const getDrawEndpoints = builder => ({
  getDrawForecastFetch: builder.query({
    query: _ref2 => {
      let drawNumber = _ref2.drawNumber,
        productId = _ref2.productId;
      return resolveDrawForecastPath({
        drawNumber,
        productId
      });
    },
    transformResponse: (res, meta, _ref3) => {
      let productId = _ref3.productId;
      return normalizeDrawForecast(res.forecastResult, productId);
    },
    keepUnusedDataFor: TWO_MINUTES
  }),
  getDrawForecast: builder.query({
    query: _ref4 => {
      let drawNumber = _ref4.drawNumber,
        productId = _ref4.productId;
      return resolveDrawForecastPath({
        drawNumber,
        productId
      });
    },
    keepUnusedDataFor: TWO_MINUTES,
    onCacheEntryAdded: async (_ref5, _ref6) => {
      let drawNumber = _ref5.drawNumber,
        productId = _ref5.productId;
      let updateCachedData = _ref6.updateCachedData,
        cacheDataLoaded = _ref6.cacheDataLoaded,
        cacheEntryRemoved = _ref6.cacheEntryRemoved,
        dispatch = _ref6.dispatch;
      const context = {};
      const drawForecastUrl = resolveDrawForecastPath({
        drawNumber,
        productId
      });
      const onSocketUpdate = drawForecastMessage => {
        logger.info("[forecast]: Update, dId:".concat(drawNumber, " pId:").concat(productId));
        updateCachedData(draft => {
          if (drawForecastMessage) {
            Object.assign(draft, normalizeDrawForecast(drawForecastMessage.forecastResult, productId));
          }
        });
      };
      try {
        await cacheDataLoaded;
        dispatch(drawSubscriptionActions.addDrawForecastSubscription({
          productId,
          drawNumber
        }));
        logger.info("[forecast]: Subscribe, dId:".concat(drawNumber, " pId:").concat(productId));
        socket.subscribe(drawForecastUrl, onSocketUpdate, context, true, true, true);
        logger.debug('socket subscribed');
      } catch (err) {
        logger.info("[forecast]: cacheEntryRemoved resolved before cacheDataLoaded, dId:".concat(drawNumber, " pId:").concat(productId));
      }
      await cacheEntryRemoved;
      logger.debug('socket unsubscribed');
      logger.info("[forecast]: Unsubscribe, dId:".concat(drawNumber, " pId:").concat(productId));
      socket.unsubscribe(drawForecastUrl, onSocketUpdate);
      dispatch(drawSubscriptionActions.deleteDrawForecastSubscription({
        productId,
        drawNumber
      }));
    }
  }),
  getDrawResult: builder.query({
    queryFn: async _ref7 => {
      let drawNumber = _ref7.drawNumber,
        productId = _ref7.productId;
      const productDrawName = products.getSpecificDrawName(productId);
      const customHandler = http.get('/draw/1/:product/draws/:drawNumber/result', _ref8 => {
        let data = _ref8.data;
        return data;
      }, {
        config: {
          shouldUseCloud: async () => {
            const toggleName = cloudApiFeatureToggles[productDrawName.toUpperCase()];
            if (!toggleName) {
              return false;
            }
            return featureToggle(toggleName, {
              req: undefined
            });
          },
          allowedProducts: ['bomben'],
          cloudEndpointTemplate: '/v1/:product/draws/:drawNumber/result'
        }
      });
      const apiProxy = new ApiProxy([customHandler]);
      try {
        const cloudData = await apiProxy.fetch("/draw/1/".concat(productDrawName, "/draws/").concat(drawNumber, "/result"), {
          method: 'GET',
          req: undefined
        });
        return {
          data: normalizeDrawResult(cloudData.result)
        };
      } catch (err) {
        var _err$status, _err$details;
        return {
          error: {
            status: (_err$status = err.status) !== null && _err$status !== void 0 ? _err$status : 'FETCH_ERROR',
            data: (_err$details = err.details) !== null && _err$details !== void 0 ? _err$details : err.message
          }
        };
      }
    },
    keepUnusedDataFor: TWO_MINUTES,
    extraOptions: {
      maxRetries: 3
    }
  }),
  getDrawsResults: builder.query({
    queryFn: async _ref9 => {
      let productId = _ref9.productId;
      const definition = getDefinitionByProduct(productId);
      const productDrawName = definition.loadDrawsApiPath;
      const customHandler = http.get('/draw/1/:product/draws/result', _ref0 => {
        let data = _ref0.data;
        return data;
      }, {
        config: {
          shouldUseCloud: async () => {
            const toggleName = cloudApiFeatureToggles[productDrawName.toUpperCase()];
            if (!toggleName) {
              return false;
            }
            return featureToggle(toggleName, {
              req: undefined
            });
          },
          allowedProducts: ['bomben'],
          cloudEndpointTemplate: '/v1/:product/draws/result'
        }
      });
      const apiProxy = new ApiProxy([customHandler]);
      try {
        const response = await apiProxy.fetch("/draw/1/".concat(productDrawName, "/draws/result"), {
          method: 'GET',
          req: undefined
        });
        response.results = (response.results || [response.result]).filter(Boolean);
        delete response.result;
        return response;
      } catch (err) {
        logger.error("Error fetching draws results for product ".concat(productDrawName, ": ").concat(err.message));
      }
    },
    keepUnusedDataFor: TWO_MINUTES
  })
});
setGlobal('svs.components.tipsen.store.endpoints.getDrawEndpoints', getDrawEndpoints);

 })(window);